// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-password-modal {
  padding: 16px;
  min-width: 500px;
  width: 100%;
}

.reset-options {
  margin-bottom: 24px;
}

.reset-option {
  display: flex;
  align-items: center;
  padding: 12px;
  margin-bottom: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.reset-option.active {
  background-color: rgba(255, 128, 0, 0.20);
  border-color: #2C3948;
}

.reset-option input {
  margin-right: 12px;
}

.email-info {
  background-color: #f5f8ff;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 24px;
}

.email-info p {
  margin-bottom: 8px;
  margin-top: 0;
}

.password-form .form-group {
  margin-bottom: 16px;
}

.password-form label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.password-form input {
  width: 100%;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
}

.password-requirements {
  background-color: #f9f9f9;
  padding: 16px;
  border-radius: 4px;
  margin-top: 16px;
  margin-bottom: 24px;
}

.password-requirements h4 {
  margin-top: 0;
  margin-bottom: 12px;
  font-weight: 500;
  font-size: 14px;
}

.password-requirements ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.password-requirements li {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
}

.password-requirements svg {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}

.password-requirements .valid {
  color: #28a745;
}

.password-requirements .valid svg {
  fill: #28a745;
}

.password-requirements .invalid {
  color: #dc3545;
}

.password-requirements .invalid svg {
  fill: #dc3545;
}

.error-message {
  color: #dc3545;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 8px;
  background-color: #f8d7da;
  border-radius: 4px;
  font-size: 14px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
}

.modal-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #2c3948;
}

.modal-close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close-button svg {
  width: 16px;
  height: 16px;
  fill: #6c757d;
}

.modal-content {
  padding: 24px;
}

/* Pour les appareils mobiles */
@media (max-width: 768px) {
  .modal-container {
    width: 95%;
  }

  .modal-header h2 {
    font-size: 16px;
  }

  .modal-content {
    padding: 16px;
  }

  .password-requirements {
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/composants/ResetPasswordModal/ResetPasswordModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".reset-password-modal {\n  padding: 16px;\n  min-width: 500px;\n  width: 100%;\n}\n\n.reset-options {\n  margin-bottom: 24px;\n}\n\n.reset-option {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  margin-bottom: 8px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.reset-option.active {\n  background-color: rgba(255, 128, 0, 0.20);\n  border-color: #2C3948;\n}\n\n.reset-option input {\n  margin-right: 12px;\n}\n\n.email-info {\n  background-color: #f5f8ff;\n  padding: 16px;\n  border-radius: 4px;\n  margin-bottom: 24px;\n}\n\n.email-info p {\n  margin-bottom: 8px;\n  margin-top: 0;\n}\n\n.password-form .form-group {\n  margin-bottom: 16px;\n}\n\n.password-form label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.password-form input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.password-requirements {\n  background-color: #f9f9f9;\n  padding: 16px;\n  border-radius: 4px;\n  margin-top: 16px;\n  margin-bottom: 24px;\n}\n\n.password-requirements h4 {\n  margin-top: 0;\n  margin-bottom: 12px;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.password-requirements ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.password-requirements li {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n.password-requirements svg {\n  margin-right: 8px;\n  width: 16px;\n  height: 16px;\n}\n\n.password-requirements .valid {\n  color: #28a745;\n}\n\n.password-requirements .valid svg {\n  fill: #28a745;\n}\n\n.password-requirements .invalid {\n  color: #dc3545;\n}\n\n.password-requirements .invalid svg {\n  fill: #dc3545;\n}\n\n.error-message {\n  color: #dc3545;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  padding: 8px;\n  background-color: #f8d7da;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-container {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);\n  width: 90%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  color: #2c3948;\n}\n\n.modal-close-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-close-button svg {\n  width: 16px;\n  height: 16px;\n  fill: #6c757d;\n}\n\n.modal-content {\n  padding: 24px;\n}\n\n/* Pour les appareils mobiles */\n@media (max-width: 768px) {\n  .modal-container {\n    width: 95%;\n  }\n\n  .modal-header h2 {\n    font-size: 16px;\n  }\n\n  .modal-content {\n    padding: 16px;\n  }\n\n  .password-requirements {\n    padding: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
